module.exports = __webpack_public_path__ + "static/media/num2.42917697.svg";